exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:spinnericon;src:url(" + require("./spinnericon.eot?39661457") + ");src:url(" + require("./spinnericon.eot?39661457") + "#iefix) format(\"embedded-opentype\"),url(" + require("./spinnericon.woff?39661457") + ") format(\"woff\"),url(" + require("./spinnericon.ttf?39661457") + ") format(\"truetype\"),url(" + require("./spinnericon.svg?39661457") + "#spinnericon) format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-spin-\"]:before,[class^=icon-spin-]:before{font-family:spinnericon}.icon-spin-1:before{content:\"\\E80B\"}.icon-spin-2:before{content:\"\\E80A\"}.icon-spin-3:before{content:\"\\E809\"}.icon-spin-4:before{content:\"\\E808\"}.icon-spin-5:before{content:\"\\E807\"}.icon-spin-6:before{content:\"\\E806\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/theme-files/icons/spinnericon/spinnericon.css
// module id = 453
// module chunks = 0